<template>
  <div id="app">
    <Header></Header>
    <keep-alive include="Home,Aboutus,News">
      <transition name="slide-fade" mode="out-in">
        <router-view name="main" />
      </transition>
    </keep-alive>
    <Footer></Footer>
    <ChatButton></ChatButton>
  </div>
</template>
<script>
import Header from "./components/header";
import "./assets/iconfont/iconfont.css";
import "./assets/css/common.css";
import Footer from "./components/footer";
import ChatButton from "./components/module/chat/chatButton.vue";
import eventBus from "./assets/js/eventBus";
import risknoticepopup from "./components/risknoticepopup";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    ChatButton
  },
  data(){
    return{
      primaryColor : '',
      chatUrlCount: 0,
      unreadCounts: {},
      msgList: []
    }
  },
  methods:{
    riskNoticeSoundConfig() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: 'risk_notice_audio'
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          localStorage.setItem('riskNoticeSound',res.data.data);
          localStorage.setItem('riskNoticeSoundrun',0);
        });
    },
    // getting unread risk notice
    async showNotice() {
        this.intervalId = setInterval(async () => { 
            const token = sessionStorage.getItem("token");
            if(token == null){
              // auto logout time remove popup
              this.$notify.closeAll();
              localStorage.removeItem('risk_notice_id');
              localStorage.removeItem('risk_notice_content');
              localStorage.setItem('riskNoticeSoundrun',0);
            }
            if(token){
                let that = this;
                that.$http({
                    url: "/app/RiskControl/user_unread_risk_control",
                    method: "POST",
                    data: {},
                    transformRequest: [(data) => JSON.stringify(data)]
                })
                .then(ret => {
                    if (ret.data.status === 200) {
                        const risk_notice = ret.data.data; 
                        const risk_notice_old_id = localStorage.getItem('risk_notice_id');
                        if(risk_notice != '' && risk_notice != null){
                            that.$notify.closeAll();
                            localStorage.setItem('risk_notice_id',risk_notice['risk_notice_id']);
                            localStorage.setItem('risk_notice_content',risk_notice['risk_notice_detail']);
                            that.getRiskNoticePopup();
                        }else if(risk_notice_old_id != '' && risk_notice_old_id != null){
                          that.$notify.closeAll();
                          that.getRiskNoticePopup();
                        }
                    }
                });
            }
        }, 2000) 
    },
    getRiskNoticePopup(){
      let that = this;
      const router = that.$router;
      that.$notify({
          message: that.$createElement(risknoticepopup, {
          on: {
            'read-click': () => { router.push('/myaccount/risk_control'); that.$notify.closeAll(); }, // popup read button click
            'ignore-click': () => that.$notify.closeAll(), // popup ignore button click
          },}),
          dangerouslyUseHTMLString: true, // Enable HTML content
          duration: 0, // Make the notification persistent
          type: 'Warning',
          showClose: false,
          customClass: "top-center-notification",
      });
    },
    getKey(){
      let that = this;
        that.$http({
          url: "/app/Home/pc_index",
          method: "POST",
          data: {
            
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.status === 200) {
              localStorage.setItem('encript_public_key',resData.data.encript_public_key)
            }
          });
    },
    getAppVueSysConfigs(){
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/names",
          method: "post",
          data: {
            names: ["theme_colour","own_chat_link"],
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let themeColor = res.data.data['theme_colour'];
            document.documentElement.style.setProperty('--baseColor', themeColor);

            const own_chat_link = res.data.data['own_chat_link'];
            let chat_urls = [];
            // Split the input by separator
            const separatedItems = own_chat_link.split(',');

            // Push each item into the array if it's not empty
            separatedItems.forEach(item => {
              const trimmedItem = item.trim(); // Trim whitespace
              if (trimmedItem !== '') {
                chat_urls.push(trimmedItem);
              }
            });

            const chatUrl = localStorage.getItem('ownChatUrl');
            if (chatUrl == '' && chat_urls.length >= 1) {
              localStorage.setItem('ownChatUrl', chat_urls[0]);
              that.chatUrlCount++;
              that.getChatUrlChecking();
            } else {
              if (that.chatUrlCount <= chat_urls.length) {
                localStorage.setItem('ownChatUrl', chat_urls[that.chatUrlCount]);
                that.chatUrlCount++;
                that.getChatUrlChecking();
              }
            }
          }

        });
    },
    getChatUrlChecking() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/apitest",
          method: "get",
          data: {},
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          console.log(res);
          if (res.status != 200) {
            that.getAppVueSysConfigs();
          }
        });
    },
    getChatMessagesInterval() {
      setInterval(() => {
        if (sessionStorage.getItem("token") && localStorage.getItem("ownChatUrl") && localStorage.getItem("chatUpdated") == "true") {
          let orderId = localStorage.getItem("last_msg_id") ? localStorage.getItem("last_msg_id") : "";

          let that = this;
          that
            .$http({
              url: "/app/Chat/get",
              method: "post",
              data: {
                user_id: localStorage.getItem('uid'),
                receiver: localStorage.getItem('last_msg_receiver'),
                order_id: orderId
              },
              chatUrl: true,
              transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              if (res.data.status == 200) {
                const resData = res.data.data;
                // System messages handling
                that.handleSystemMessage(resData.systemMessages)

                // Normal messages handling
                if (resData.msgList && resData.msgList.length > 0) {
                  let totalUnread = 0;
                  that.unreadCounts = resData.count;

                  that.msgList = resData.msgList;
                  that.msgList.forEach(element => {
                    that.setAllMessagesList(element, true);
                  });

                  let agentList = JSON.parse(localStorage.getItem("agent_list"))
                  
                  agentList.forEach(element => {
                    totalUnread += element.count
                  })
                  eventBus.$emit('totalChanged', totalUnread);

                  const msgListReversed = that.msgList.reverse();
                  localStorage.setItem('last_msg_id', msgListReversed[0].order_id)
                  localStorage.setItem('last_msg_receiver', msgListReversed[0].receiver)

                  that.markChatDelivered()
                }
              }
            });
        }
      }, 3000)
    },
    handleSystemMessage(systemMessages) {
      if (systemMessages.msgList.length > 0) {
        systemMessages.msgList.forEach((message) => {
          const availableMessages = localStorage.getItem("systemMessages") ? JSON.parse(localStorage.getItem("systemMessages")) : [];
          const messageAvailable = availableMessages.length ? availableMessages.find(element => element.order_id == message.order_id) : false;

          if (!messageAvailable) {
            message.readStatus = false
            availableMessages.push(message)
            localStorage.setItem("systemMessages", JSON.stringify(availableMessages))
            localStorage.setItem("last_msg_id", message.order_id)
            localStorage.setItem("last_msg_receiver", message.receiver)

            let availableCount = localStorage.getItem("systemUnread");
            availableCount = availableCount && !isNaN(availableCount) ? parseInt(availableCount, 10) : 0;
            availableCount++;

            if (localStorage.getItem("chatAgentId") != "SYSTEM") {
              localStorage.setItem('systemUnread',availableCount)
            } else{
							localStorage.setItem('systemUnread',0);
						}
            eventBus.$emit('updateTotalCount');

            eventBus.$emit("onChatReceived", message);
          }
        })
      }
    },
    setAllMessagesList(messageItem, isEmit) {
      const agentList = JSON.parse(localStorage.getItem("agent_list")) || [];

      if (messageItem.type == -100) {
        // Deleted message
        const deleted = localStorage.getItem("deletedMsgs") ? JSON.parse(localStorage.getItem("deletedMsgs")) : []
        deleted.push(messageItem.message);
        localStorage.setItem("deletedMsgs", JSON.stringify(deleted))
        eventBus.$emit("msgDeleted", messageItem.message);

        agentList.forEach((e) => {
          e.messages.forEach((el) => {
            if (el.order_id == messageItem.message) {
              el.type = -100;
            }
          })
          if (e.unreadMsgIds) {
            const unreadIndex = e.unreadMsgIds.findIndex(item => item == messageItem.message)
            if (unreadIndex > -1) {
              e.unreadMsgIds.splice(unreadIndex, unreadIndex);
              e.count--;
              if (e.count < 0) {
                e.count = 0;
              }
            }
          }
        })
        localStorage.setItem('agent_list', JSON.stringify(agentList))
        eventBus.$emit("updateTotalCount")
      } else {
        if (agentList && agentList.length > 0) {
          agentList.forEach(element => {
            const isMsgExist = element.messages.find(item => item.order_id == messageItem.order_id);

            if (!isMsgExist) {
              if (element.number == messageItem.receiver || element.number == messageItem.sender) {
                element.messages.push(messageItem);
                element.last_msg = messageItem;
                element.count++;
                element.unreadMsgIds ? element.unreadMsgIds.push(messageItem.order_id) : element.unreadMsgIds = [messageItem.order_id]

                if (isEmit) {
                  eventBus.$emit("onChatReceived", messageItem);
                }
              }
              // Sort the messages by time
							element.messages.sort((a, b) => a.time - b.time);
            }
          })
          localStorage.setItem("agent_list", JSON.stringify(agentList));
        }
      }
    },
    markChatDelivered() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/markDelivered",
          method: "post",
          data: {},
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status != 200) {
            that.$message.error(that.$t(res.data.msgId));
          }
        })
    },
    getOfflineMessages() {
      setInterval(() => {
        if (sessionStorage.getItem("token") && localStorage.getItem("ownChatUrl") && localStorage.getItem("chatUpdated")) {
          let orderId = localStorage.getItem("last_msg_id") || ""

          let that = this;
          that
            .$http({
              url: "/app/Chat/getOfflineMsg",
              method: "post",
              data: {
                user_id: localStorage.getItem('uid'),
                receiver: localStorage.getItem('last_msg_receiver'),
                order_id: orderId
              },
              chatUrl: true,
              transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              if (res.data.status == 200) {
                const resData = res.data.data;
                // System messages handling
                that.handleSystemMessage(resData.systemMessages)

                // Normal messages handling
                if (resData.msgList && resData.msgList.length > 0) {
                  let totalUnread = 0;
                  that.unreadCounts = resData.count;

                  that.msgList = resData.msgList;
                  that.msgList.forEach(element => {
                    that.setAllMessagesList(element, true);
                  });

                  let agentList = JSON.parse(localStorage.getItem("agent_list"))
                  agentList.forEach(element => {
                    totalUnread += element.count;
                  })
                  eventBus.$emit('totalChanged', totalUnread);

                  const msgListReversed = that.msgList.reverse();
                  localStorage.setItem('last_msg_id', msgListReversed[0].order_id)
                  localStorage.setItem('last_msg_receiver', msgListReversed[0].receiver)
                }
              }
            });
        }
      }, 60000)
    }
  },
  watch: {
    // 使用watch 监听$router的变化
    /*$route(to, from) {
      clearInterval(window.timer1);
      clearInterval(window.timer2);
      clearInterval(window.timer3);
    },*/
  },
  mounted(){
    this.getAppVueSysConfigs()
    this.getChatMessagesInterval()
    this.getOfflineMessages()
    this.getKey();
    this.showNotice();
    this.riskNoticeSoundConfig();
  }
};
</script>
<style lang="less" scoped>
  #app{
    background: #f0f0f0;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>

<style>

  .el-dialog__header{
    text-align: center;
  }

  .el-message-box__title{
    text-align: center;
  }

  .el-dialog__body{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .dialogConfirm {
    background-color: var(--baseColor) !important;
    border-color: var(--baseColor) !important;
  }

  .dialogCancel:hover {
    color: var(--baseColor) !important;
    border-color: var(--baseColor) !important;
    background-color: #fff !important;
  }
  #accountSelector .el-select-dropdown__item .selected {
    color: var(--baseColor) !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue